import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure45 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      xAxis: [{
        categories: [ 2015, 2016, 2017, 2018, 2019, 2020 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 90,
        min: 0,
        tickInterval: 10,
	title: {
	useHTML: true,
            text: "USD/m³",
            offset: 50,
            style: {
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ 
        {
        name: 'Asia central y Asia meridional',
        type: 'line',
            color: '#5b9bd6',
        zoneAxis: 'x',
        data: [2.48, 2.64, 2.78, 2.93, 2.99, 2.86
        ],
    },
    {
        name: 'América septentrional y Europa',
        type: 'line',
        color: '#ed7e31',
        zoneAxis: 'x',
        data: [47.48, 48.24, 49.31, 50.44, 51.58, 49.51

        ],
    },
    {
        name: 'Asia occidental y África septentrional',
        type: 'line',
        color: '#a6a5a4',
        zoneAxis: 'x',
        data: [11.73, 11.87, 11.95, 12.51, 11.66, 11.15
        ],
    },
    {
        name: 'África subsahariana',
        type: 'line',
        color: '#ffbf00',
        zoneAxis: 'x',
        data: [ 12.73, 12.58, 12.88, 12.96, 13.35, 12.82
        ],
    },

    {
        name: 'América Latina y el Caribe',
        type: 'line',
        color: '#4372c4',
        zoneAxis: 'x',
        data: [ 13.41, 12.97, 13.04, 13.00, 12.81, 11.79
         ],
    },
    {
        name: 'Oceanía',
        type: 'line',
        color: '#71ad49',
        zoneAxis: 'x',
        data: [ 58.69, 61.19, 62.07, 62.53, 69.11, 76.81
        ],
    },
    {
        name: 'Asia oriental y Asia sudoriental',
        type: 'line',
        color: '#265e91',
        zoneAxis: 'x',
        data: [15.71, 16.56, 17.44, 19.00, 19.53, 19.91
        ],
        },
        {
            name: 'Mundo',
            type: 'line',
            color: '#9e480e',
            zoneAxis: 'x',
            data: [17.39, 17.8, 18.32, 19.12, 19.38, 18.9
            ],
        },

  ],

}